var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 17.8496C5.41797 17.8496 1.66797 14.2496 1.66797 9.84961C1.66797 5.44961 5.41797 1.84961 10.0013 1.84961C14.5846 1.84961 18.3346 5.44961 18.3346 9.84961C18.3346 14.2496 14.5846 17.8496 10.0013 17.8496ZM10.0013 3.44961C6.33463 3.44961 3.33464 6.32961 3.33464 9.84961C3.33464 13.3696 6.33463 16.2496 10.0013 16.2496C13.668 16.2496 16.668 13.3696 16.668 9.84961C16.668 6.32961 13.668 3.44961 10.0013 3.44961Z",
    fill: "#F29439"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0846 10.6489H10.0013C9.5013 10.6489 9.16797 10.3289 9.16797 9.84891V5.92891C9.16797 5.44891 9.5013 5.12891 10.0013 5.12891C10.5013 5.12891 10.8346 5.44891 10.8346 5.92891V9.04891H14.0846C14.5846 9.04891 14.918 9.36891 14.918 9.84891C14.918 10.3289 14.5846 10.6489 14.0846 10.6489Z",
    fill: "#F29439"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/pending_icon.5b3bd81d74bf8499a052b4498dd7ec19.svg";
export { ForwardRef as ReactComponent };